/* import __COLOCATED_TEMPLATE__ from './predicates-radio.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();